module.exports = __webpack_public_path__ + "static/media/bts_lalela_170711_029_small.46ab5b74.jpg";